var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18.757 2.59 2.834 2.833c.781.781.782 2.046.001 2.827L8.195 21.648a1.381 1.381 0 0 1-.856.352H3.173c-.553 0-1-.445-1-1v-4.166c0-.278.16-.663.352-.856l13.404-13.39a2 2 0 0 1 2.828.001ZM4.173 17.153l.001.938a1.5 1.5 0 0 1 1.904 1.913l.929.002 1.55-1.55-2.842-2.843-1.542 1.54Zm14.005-8.318-2.835-2.833-8.212 8.198 2.84 2.841 8.207-8.206Z"
  })));
};

export default SvgEdit;